import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { getSmartBackTarget } from "../lib/navHistoryStack";

export function BackButton({
  fallback = "/allmatchs",
  className = "",
  desktopTopPx = 24, // top sur desktop (px)
  mobileExtraPx = 12, // marge sous la safe-area (px)
}: {
  fallback?: string;
  className?: string;
  desktopTopPx?: number;
  mobileExtraPx?: number;
}) {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => setMounted(true), []);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 640px)"); // Tailwind sm
    const update = () => setIsDesktop(mq.matches);
    update();
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);

  const handleBack = () => {
    const target = getSmartBackTarget();
    if (target) navigate(target);
    else navigate(fallback);
  };

const top = isDesktop
  ? `${desktopTopPx}px`
  : `calc(env(safe-area-inset-top, 0px) + ${mobileExtraPx}px)`;


  const btn = (
    <button
      onClick={handleBack}
      aria-label="Back"
      className={`
        fixed left-6 sm:left-30
 z-[9999]
        flex items-center justify-center
        h-10 w-10 rounded-full
        bg-white/80 backdrop-blur shadow-md
        hover:bg-white
        dark:bg-gray-900/80 dark:hover:bg-gray-900
        ${className}
      `}
      style={{ top }}
    >
      <ChevronLeft size={18} />
    </button>
  );

  if (!mounted) return null;
  return createPortal(btn, document.body);
}
